import { PrintCardMenu } from './print-card-menu';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { AssetLibraryType } from '../../enum/dto/asset-library-type.enum';

export class StiiizyStrainPrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.Archivo.Regular_400,
      FONT.Archivo.SemiBold_600,
      FONT.Archivo.Bold_700,
      FONT.Archivo.ExtraBold_800,
      FONT.Archivo.Black_900
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/eul6eqn.css';
  }

  shouldFetchVariantAssets(): boolean {
    return true;
  }

  variantAssetTypeSortOrder(): string[] {
    return [AssetLibraryType.PrimaryBrand, AssetLibraryType.AlternateBrand, AssetLibraryType.Brand];
  }

  /**
   * Stiiizy cards ask for 2 assets to be returned instead of 1, because there is an inverse version of the card, where
   * the background is black and the brand asset needs to be white, so in this scenario the alternative brand asset
   * is also needed.
   */
  variantAssetItemCount(): number {
    return 2;
  }

  shouldStandardizeDominantStrainType(): boolean {
    return false;
  }
}
